import { defineStore } from "pinia";
import { ref, computed, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "allowedDocumentType";

export const useAllowedDocumentTypeStore = defineStore(storeName, () => {
  const all = ref([]);

  const { baseFetchAll } = useBase(storeName);

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("allowed-document-types", errorCallback);
  };

  const allowedExtensions = computed(() =>
    all.value.map((t) => t.attributes.extension)
  );

  const allowedMimeTypes = computed(() =>
    [...new Set(all.value.map((t) => t.attributes.mimeType))]
  );

  const maxSizeFor = (extension) => {
    const ext = extension.replace(/^\./, "").toLowerCase();
    const type = all.value.find((t) => t.attributes.extension === ext);
    return type ? type.attributes.maxFileSizeMb : null;
  };

  const acceptString = computed(() =>
    allowedMimeTypes.value.join(",")
  );

  onMounted(async () => {
    await fetchAll();
  });

  return {
    all,
    fetchAllowedDocumentTypes: fetchAll,
    allowedExtensions,
    allowedMimeTypes,
    maxSizeFor,
    acceptString,
  };
});
